import { REDIRECT_URL_PARAM } from '@/constants/pages';
import { ROUTE } from '@/core/api';

export type GetLoginPathToOrganizationParams = {
  org_id: string;
  [REDIRECT_URL_PARAM]?: string;
};

export const getLoginPathToOrganization = ({ org_id, redirectUrl }: GetLoginPathToOrganizationParams) => {
  const urlParams = new URLSearchParams({ org_id });
  if (redirectUrl) {
    urlParams.append(REDIRECT_URL_PARAM, redirectUrl);
  }
  return `${ROUTE.USER.SILENT_LOGIN}?${urlParams.toString()}`;
};
